module.exports = __webpack_public_path__ + "gs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gs.svg
// module id = 836
// module chunks = 0